import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

const safeSelector = (root: RootState) => root.selectedSite;

export const getSelectedSiteLoadingSelector = createSelector(
  safeSelector,
  (state) => state.loading,
);
export const getSelectedSiteErrorSelector = createSelector(safeSelector, (state) => state.error);
export const getSelectedSiteDataSelector = createSelector(safeSelector, (state) => state.data);
